import * as types from './actionTypes';
import { getUserOrganizationsForOrgId, getUserOrganizationsTopLevel } from '../api/userApi';

export function addToGlobalFilter(branch, merchantCount, merchantIndex) {
  return { type: types.ADD_TO_GLOBAL_FILTER, branch, merchantCount, merchantIndex };
}

export function addToGlobalFilterOrgIds(orgIds) {
  return { type: types.ADD_TO_GLOBAL_FILTER_ORG_IDS, orgIds };
}

export function updateGlobalFilter(filters, orgIds, merchantCount, lowestLevelSelected) {
  return { type: types.UPDATE_GLOBAL_FILTER, filters, orgIds, merchantCount, lowestLevelSelected };
}

export function updateScheduleGlobalFilter(filters, orgIds, merchantCount, merchantList) {
  return { type: types.UPDATE_SCHEDULE_GLOBAL_FILTER, filters, orgIds, merchantCount, merchantList };
}

export function addSupportOrgIdToGlobalOrgIds(orgIds) {
  return { type: types.ADD_SUPPORT_REQUEST_ORGID_TO_GLOBAL_ORG_IDS, orgIds };
}

export function removeFromGlobalFilter(branch) {
  return { type: types.REMOVE_FROM_GLOBAL_FILTER, branch };
}

export function clearGlobalFilter() {
  return { type: types.CLEAR_GLOBAL_FILTER };
}

export function clearSupportRequestGlobalFilter() {
  return { type: types.CLEAR_SUPPORT_REQUEST_GLOBAL_FILTER };
}

// fetchUserOrganizations(userId, orgId)  ---------------------------------------------------
export function fetchUserOrganizations(userId, orgId, topLevel = false) {
  return function dispatchUserOrganizations(dispatch) {
    dispatch(requestUserOrganizations());
    const getOrgs = (topLevel) ? getUserOrganizationsTopLevel : getUserOrganizationsForOrgId;
    return getOrgs(userId, orgId)
      .then((dataAccess) => {
        dispatch(receiveUserOrganizationsSuccess(orgId, dataAccess));
      })
      .catch((error) => {
        dispatch(receiveUserOrganizationsFailure(error));
      });
  };
}

export function requestUserOrganizations() {
  return { type: types.REQUEST_USER_ORGANIZATIONS };
}

export function receiveUserOrganizationsSuccess(orgId, dataAccess) {
  return {
    type: types.RECEIVE_USER_ORGANIZATIONS_SUCCESS,
    orgId,
    userOrganizations: dataAccess,
    receivedAt: Date.now(),
  };
}

export function receiveUserOrganizationsFailure(error) {
  return {
    type: types.RECEIVE_USER_ORGANIZATIONS_FAILURE,
    error,
  };
}
